// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__33Vmd","requiredAsterisk":"Info_requiredAsterisk__8vwO4"};